import React, { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';

import {
  Header,
  ComboBox,
  TextInput,
  InputMaskField,
  Button,
  Radio,
  FLink,
  Tabs,
  Table,
} from '@components';
import { currency } from '@utils';

export const StyleguidePage = () => {
  const [selectValue, setSelectValue] = useState('Fevereiro');
  const [textValue, setTextValue] = useState('Teste');
  const [maskValue, setMaskValue] = useState('11111111');

  const handleSelectChange = (val) => {
    setSelectValue(val);
  };

  const handleTextChange = (val) => {
    setTextValue(val);
  };

  const handleMaskChange = (val) => {
    setMaskValue(val);
  };
  return (
    <>
      <Helmet>
        <title>Styleguide</title>
      </Helmet>
      <h1>Styleguide</h1>
      <hr />
      <h3>Header</h3>
      <Header />
      <hr />
      <h3>Select Input</h3>
      <div className="row">
        <div className="col-6">
          <ComboBox
            options={[
              'Janeiro',
              'Fevereiro',
              'Março',
              'Abril',
              'Maio',
              'Junho',
              'Julho',
            ].map((x) => {
              return { value: x, label: x };
            })}
            defaultValue={selectValue}
            onChange={handleSelectChange}
            color="orange"
            name="select"
          />
        </div>
        <div className="col-6">
          <ComboBox
            options={[
              'Janeiro',
              'Fevereiro',
              'Março',
              'Abril',
              'Maio',
              'Junho',
              'Julho',
              'Janeiro',
              'Fevereiro',
              'Março',
              'Abril',
              'Maio',
              'Junho',
              'Julho',
              'Janeiro',
              'Fevereiro',
              'Março',
              'Abril',
              'Maio',
              'Junho',
              'Julho',
            ].map((x) => {
              return { value: x, label: x };
            })}
          />
        </div>
      </div>
      <hr />
      <h3>Text Input</h3>
      <div className="row">
        <div className="col-6">
          <TextInput id="teste1" label="Label" disabled />
        </div>
        <div className="col-6">
          <TextInput
            id="teste2"
            label="Label"
            value={textValue}
            onChange={handleTextChange}
          />
        </div>
      </div>
      <h3>Input Mask</h3>
      <div className="row">
        <div className="col-6">
          <InputMaskField
            value={maskValue}
            mask="11/11/1111"
            inputMode="numeric"
            pattern="*[0-9]"
            label="Data de nascimento"
            onChange={handleMaskChange}
          />
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-6">
          <h3>Button</h3>
          <Button disabled>Registrar ocorrência</Button>
          <br />
          <Button onClick={() => {}}>Registrar ocorrência</Button>
          <br />
          <Button transparent color="orange">
            Registrar ocorrência
          </Button>
        </div>
        <div className="col-6">
          <h3>Icon Button</h3>
          <Button disabled>Registrar ocorrência</Button>
          <br />
          <Button onClick={() => {}}>Registrar ocorrência</Button>
          <br />
          <Button transparent color="orange">
            Registrar ocorrência
          </Button>
        </div>
      </div>
      <hr />
      <h3 className="mb-3">Table</h3>
      <Table columns={['', 'Você', 'Empresa', 'Total']}>
        <tr>
          <td className="fw-bold">DEZ</td>
          <td>{currency(366.1)}</td>
          <td>{currency(366.1)}</td>
          <td className="fw-bold">{currency(732.21)}</td>
        </tr>
        <tr>
          <td className="fw-bold">NOV</td>
          <td>{currency(366.1)}</td>
          <td>{currency(366.1)}</td>
          <td className="fw-bold">{currency(732.21)}</td>
        </tr>
        <tr>
          <td className="fw-bold">OUT</td>
          <td>{currency(366.1)}</td>
          <td>{currency(366.1)}</td>
          <td className="fw-bold">{currency(732.21)}</td>
        </tr>
        <tr>
          <td className="fw-bold">SET</td>
          <td>{currency(366.1)}</td>
          <td>{currency(366.1)}</td>
          <td className="fw-bold">{currency(732.21)}</td>
        </tr>
      </Table>
      <hr />
      <h3>Links</h3>
      <div className="row">
        <div className="col-4">
          <FLink disabled to="/" icon>
            Ver todas as notícias
          </FLink>
          <FLink to="/" icon>
            Ver todas as notícias
          </FLink>
        </div>
      </div>
      <hr />
      <h3>Chat</h3>
      <hr />
      <div className="row">
        <div className="col-6">
          <h3 className="mb-3">Radio button</h3>
          <Radio name="radio" value="1" id="radio1" label="Teste 1" />
          <Radio
            defaultChecked
            name="radio"
            value="2"
            id="radio2"
            label="Teste 2"
            color="orange"
          />
        </div>
        <div className="col-6">
          <h3 className="mb-3">Grouped Radio buttons</h3>
          <fieldset id="group1">
            <Radio id="radio3" name="group1" value="Value 1" label="Teste 1" />
            <Radio id="radio4" name="group1" value="Value 2" label="Teste 2" />
            <Radio id="radio5" name="group1" value="Value 3" label="Teste 3" />
          </fieldset>
        </div>
      </div>
      <hr />
      <h3>Tabs</h3>
      <Tabs active="Dados pessoais">
        <div label="Dados pessoais">
          See ya later, <em>Alligator</em>!
        </div>
        <div label="Residenciais">
          After while, <em>Crocodile</em>!
        </div>
        <div label="Beneficiários">
          Nothing to see here, this tab is <em>extinct</em>!
        </div>
      </Tabs>
    </>
  );
};
